// Logica di home
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Grid } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function CategoriesList({ classes, noProduct, products }) {
	const navigate = useNavigate()
	const categoryParam = useParams()['*']
	const { categories, categoriesArray } = useSelector(state => state.products)
	const shop = useSelector(state => state.shop)
	const catDisplayMode = shop.profiles.ueby_categories_display_mode
	const catListDisplayMode =  shop.profiles.ueby_categories_list_display_mod

	const categorySelected = categories.filter(c =>c.ecom_url == categoryParam)

	const handleCategorySelected = (ecom_url, subCat) => {
		navigate(`/shop/${ecom_url}`)
	}

	const myCategory = categoriesArray.filter(c => c.ecom_url == categoryParam)
	const subcategories = categoriesArray.filter(sub => sub.parent_id == myCategory[0].category_id)

	useEffect(() => {
		// Torno in cima alla lista quando entro nella lista categorie
		setTimeout(() => {
			window.scrollTo(0, 0)
		}, 100)
	}, [])

	return (
		<React.Fragment>
			<div className={classes.homeBackground}></div>

			<div className={classes.page} style={{ width: '91vw' }}>
				<h3 className={classes.pageTitle}>{myCategory[0].name}</h3>

				<Grid container spacing={1} className={classes.productsList}>
					{subcategories.map((sub) => (
						<Grid key={sub.category_id} item xs={12} sm={6} md={4} lg={3} xl={2}>

							<div className="product grid" onClick={() => handleCategorySelected(sub.ecom_url)}>

								{
									parseInt(catListDisplayMode) == 1
										?
										<>
											<div className="pic">
												<img style={{ width: '80%'  }} src={`${window.__endpoint}/images/products/m/${sub.main_image ? sub.main_image.image_id : 'missing'}.jpg`} alt={sub.name} />
											</div>
											<div>
												{sub.name}
											</div>
										</>
										:
										<div className="titleContainer">
											<span className="titleCategory">{sub.name}</span>
										</div>
								}
							</div>
						</Grid>
					))}
				</Grid>
			</div>
		</React.Fragment>
	)
}

export default withStyles(style)(CategoriesList)
